const SidebarCheckbox = ({
  data = [],
  allElement = () => null,
  handleChange,
  checked,
  renderName = () => "",
}) => {
  return (
    <ul className={["filter-list"]}>
      {allElement(data)}
      {data &&
        data.map((item) => (
          <li key={item?.id}>
            <div className="ch-checkbox">
              <label>
                <input
                  type="checkbox"
                  onChange={(e) => handleChange(e, item)}
                  checked={checked(item)}
                />{" "}
                <span> {renderName(item)}</span>
              </label>
            </div>
          </li>
        ))}
    </ul>
  );
};
export default SidebarCheckbox;
